<div *ngIf="visible"
     role="dialog"
     id="success-error-dialog"
     class="modal fade in ui-draggable ui-draggable-handle locationAlertDataPane"
     style="display: block;  width:auto; height:auto; overflow-x: auto; overflow-y:auto; max-width: 100%; max-height: 100%; "
     appDraggable dragTarget="#success-error-dialog" dragHandle="#successErrorDialogHeader" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" id="successErrorDialogHeader">
        <button type="button" class="close" (click)="hide()">x</button>
        <h4 class="modal-title">
          <i *ngIf="errorVisible" class="fa fa-exclamation-circle" style="color: red;"></i>
          <i *ngIf="successVisible" class="fa fa-check" style="color: green;"></i>
          {{ title }}
        </h4>
      </div>
      <div class="modal-body">
        <p>{{ message }}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default" (click)="hide()">CLOSE</button>
      </div>
    </div>
  </div>
</div>
